import _ from "lodash";
import {message} from "@grininc/grin-ui";

export default {
    data() {
        return {
            isFileUploading: false,
        }
    },

    computed: {
        fileUploadUrl() {
            return `/campaigns/proposal/${this.proposalId}/files/upload`;
        },

        proposalFiles() {
            return _.get(this, 'proposal.files', []);
        },

        proposalFileUrl() {
            return `/api/v1/proposals/${this.proposalId}/files`;
        },
    },

    methods: {
        handleFileUpload(info) {
            this.isFileUploading = true;
            this.handleUploadChange(info, () => {
                this.loadProposal(true)
                    .then(() => {
                        message.success('File uploaded.');
                        this.isFileUploading = false;
                    });
            });
        },

        handleFileDelete(data) {
            this.$http.delete(`${this.proposalFileUrl}/${data.file}`)
                .then(() => {
                    this.loadProposal(true)
                        .then(() => message.success('File deleted.'));
                }, () => message.error('Failed to delete file.'));
        },
    },
}
